/**
 * Canonical public-facing product name — use for UI, emails, and metadata.
 */
export const BRAND_NAME = "Tax Lien Vest";

/**
 * Short monogram for lime badge lockups (imagery hero, check-in panels, etc.).
 */
export const BRAND_MONOGRAM = "TLV";
